module.exports = __webpack_public_path__ + "img/banner2.070e033d.png";